import {
    type AgentConversationRead,
    type AgentTraceDetail,
} from '@libraries/typescript/api_client';

export function mapAdminTraceToConversation(
    trace: AgentTraceDetail | undefined,
): AgentConversationRead | undefined {
    if (!trace) {
        return undefined;
    }

    return {
        id: trace.id,
        title: null,
        conversation_type: 'admin_playground',
        execution_backend: trace.execution_backend,
        active_model: trace.active_model,
        resolved_model: trace.resolved_model,
        created_at: trace.created_at,
        updated_at: trace.updated_at,
        last_turn_at: trace.last_turn_at,
        agent_thinking: trace.agent_thinking,
        phoebe_run_id: null,
        turns: trace.turns.map((turn) => ({
            id: turn.id,
            sequence: turn.sequence,
            created_at: turn.created_at,
            updated_at: turn.updated_at,
            provider_response_id: turn.provider_response_id,
            items: turn.items.map((item) => ({
                id: item.id,
                created_at: item.created_at,
                direction: item.direction,
                role: item.role,
                type: item.type,
                index_in_turn: item.index_in_turn,
                text_content: item.text_content,
                call_id: item.call_id,
                tool_name: item.tool_name,
                tool_status: item.tool_status,
                arguments_json: item.arguments_json,
                output_json: item.output_json,
                raw_json: item.raw_json,
            })),
        })),
    };
}
